export const isIntersect = (array1: unknown[], array2: unknown[]): boolean =>
  array1.some(arrayItem => array2?.includes(arrayItem));
